import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* addCampaignUsers({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.addUsers, id, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.addCampaignUsersDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.addCampaignUsersFailed,
      handledErrors,
      endpoint: api.modifiers.assignments.addUsers.url
    });
  }
}

export const addCampaignUsersSaga = takeEvery(types.ADD_CAMPAIGN_USERS_REQUEST, addCampaignUsers);